import leven from "leven"
import FlexSearch from "flexsearch"

// Create a FlexSearch index
const index = new FlexSearch.Document({
  document: {
    id: "objectId",
    index: ["name"], // Fields to index for search
    store: true, // Fields to retrieve in results
  },
  language: "fr", // Language support for tokenization
  tokenize: "forward", // Tokenization for autocompletion
  encoder: "simple", // Simplified text encoding for search
  threshold: 3, // Fuzzy search tolerance
  resolution: 5, // Higher resolution for more accurate results
})

// Add data to the index
export const addDataToIndex = (data) => {
  data.forEach((item) => {
    index.add(item)
  })
}

export const searchIndex = async (query) => {
  try {
    // BUG: puck does not exists in flexseach types
    const result = await index.searchAsync(query, {
      index: ["name"],
      suggest: true,
      pluck: "name", // we only need the name
      enrich: true, // enrich the result format
    })

    return result
  } catch (error) {
    console.error("Error during FlexSearch tokenization:", error)
    return []
  }
}

/**
 * Get autocorrected results using Levenshtein distance
 * e.g: fexsearch => flexsearch
 */
export const suggestIndex = (search, data) => {
  const suggestions = data.filter((item) => {
    const length = item.name.length
    const distance = leven(search.toLocaleLowerCase(), item.name.toLocaleLowerCase())

    // if the search is too short, the distance should be higher
    if (length > 35 && search.length <= 10) {
      const maxDistance = length - distance
      return maxDistance >= 5
    }
    const maxDistance = Math.max(2, Math.floor(length * 0.1)) // Adjust threshold based on length
    return distance <= maxDistance
  })
  
  return suggestions
}